import React, { useEffect, useState } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid';

import ContentCard from '../../../components/ContentCard';
import DataGrid from '../../../components/DataGrid';
import StudentStateChip from '../../../components/StudentStateChip';
import { useGetStudentsQuery } from '../../../services/students';
import { CourseState, ShortStudent } from '../../../services/students/types';
import { CourseEnrolmentState, StudentState } from '../../../types/common';

interface ShortStudentRefund extends ShortStudent {
  credits: number,
}

const RefundsTab = () => {
  const { data: students, isLoading: isStudentsLoading } = useGetStudentsQuery({});

  const [studentsToRefund, setStudentsToRefund] = useState<ShortStudentRefund[]>([]);

  useEffect(() => {
    if (students) {
      setStudentsToRefund(students.data.filter((student) => student.requiresRefund === true)
        .map((student) => {
          let credits = 0;
          Object.values(student.courseStates ?? {}).forEach((course: CourseState) => {
            if (course.state === CourseEnrolmentState.Unenrolled) {
              if (course.extraCredits > 0) {
                credits += course.extraCredits;
              }
              if (course.termCredits > 0) {
                credits += course.termCredits;
              }
            }
          });

          return {
            ...student,
            credits,
          };
        })
        // sort by credits
        .sort((a, b) => b.credits - a.credits),
      );
    }
  }, [students]);

  const renderStudentState = (params: GridRenderCellParams<any, string>) => (
    <StudentStateChip size="small" state={params.value as StudentState} />
  );

  return (
    <ContentCard title={`${studentsToRefund.length} refunds to issue`} variant="transparent" padding="none">
      <DataGrid
        columns={[
          {
            field: 'state',
            headerName: 'State',
            width: 170,
            renderCell: renderStudentState,
          },
          {
            field: 'gradYear',
            headerName: 'Grad Year',
            width: 100,
          },
          {
            field: 'school',
            headerName: 'School',
            width: 200,
          },
          {
            field: 'name',
            headerName: 'Name',
            width: 200,
          },
          {
            field: 'credits',
            headerName: 'Credits',
            width: 200,
          },
        ]}
        rows={studentsToRefund}
        loading={isStudentsLoading}
        getRowHref={(row: ShortStudentRefund) => `/admin/student/${row.id}/?tab=billing`}
      />
    </ContentCard>
  );
};
export default RefundsTab;
